<template>
    <div class="col-lg-12">
        <div class="apprentice-simple-card">
            <div class="title">
                <h5 v-if="required">{{ $t('group_pair.teacher_choice_mandatory') }}</h5>
                <h5 v-else>{{ $t('group_pair.teacher_choice') }}</h5>
            </div>

            <p>
                {{
                    $t('group_pair.teacher_choice_info', {
                        teachers: $tc('group_pair.teacher_amount', maxTeachersIn),
                    })
                }}
            </p>

            <br />

            <design-2021-apprentice-data-table
                :items="teachers"
                :fields="fields">
                <template v-slot:cell(requests)="data">
                    <div class="teacher-group-open-count">
                        {{ data.item.requests }}
                    </div>
                </template>

                <template v-slot:cell(group_count)="data">
                    <div
                        class="teacher-group-count"
                        v-if="data.item.max">
                        {{ data.item.group_count }} / {{ data.item.max }}
                    </div>
                    <div
                        class="teacher-group-count"
                        v-else>
                        n.v.t.
                    </div>
                </template>

                <template
                    v-slot:cell(actions)="data"
                    v-if="!error">
                    <b-button
                        class="btn-add btn-show-skill-tree remove-icon-margin"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('group_pair.add_teacher')"
                        @click="addTeacher(data.item.model)">
                    </b-button>
                </template>
            </design-2021-apprentice-data-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'group-pair-teacher-component',
    props: ['selectedTeachersIn', 'teachersIn', 'required', 'teacherMaxForced', 'checkOption', 'maxTeachersIn'],
    data() {
        return {
            error: false,
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'courses',
                    label: this.$t('group_pair.courses'),
                },
                {
                    key: 'requests',
                    label: this.$t('group_pair.open_requests'),
                },
                {
                    key: 'group_count',
                    label: this.$t('group_pair.groups'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.choose'),
                },
            ],
        };
    },
    computed: {
        teachers() {
            const selectedTeacherIds = this.selectedTeachersIn.map((teacher) => teacher.id);
            if (this.selectedTeachersIn.length >= this.maxTeachersIn) {
                this.error = true;
            } else {
                this.error = false;
            }
            let teacherArray = this.teachersIn.filter((teacher) => !selectedTeacherIds.includes(teacher.user.id));
            return teacherArray.map((teacher) => {
                return {
                    id: teacher.id,
                    name: teacher.user.full_name,
                    courses: teacher.courses,
                    requests: this.countTeacherRequests(teacher),
                    group_count: this.countTeacherGroups(teacher),
                    max: teacher.max,
                    model: teacher,
                };
            });
        },
    },
    methods: {
        addTeacher(teacher) {
            this.$emit('add-teacher', teacher);
        },
        countTeacherRequests(teacher) {
            let count = 0;

            for (const group of teacher.user.group_pair_group_teachers) {
                if (this.checkOption === 1 && group.group_pair_groups.check_teacher !== 2) {
                    count++;
                } else if (
                    this.checkOption === 2 &&
                    (group.group_pair_groups.check_teacher !== 2 || group.group_pair_groups.check_coordinator !== 2)
                ) {
                    count++;
                } else if (this.checkOption === 3 && group.group_pair_groups.check_coordinator !== 2) {
                    count++;
                }
            }

            return count;
        },
        countTeacherGroups(teacher) {
            let count = 0;

            for (const group of teacher.user.group_pair_group_teachers) {
                if (this.checkOption === 1 && group.group_pair_groups.check_teacher === 2) {
                    count++;
                } else if (
                    this.checkOption === 2 &&
                    group.group_pair_groups.check_teacher === 2 &&
                    group.group_pair_groups.check_coordinator === 2
                ) {
                    count++;
                } else if (this.checkOption === 3 && group.group_pair_groups.check_coordinator === 2) {
                    count++;
                }
            }

            return count;
        },
    },
};
</script>

<style scoped>
>>> .teacher-group-count {
    white-space: normal;
}

>>> .teacher-group-open-count {
    white-space: normal;
}
</style>
